<template>
    <div>
        <my-table :data="tableData" :height="tableHeight" v-if="waitInit">
            <el-table-column label="报告编码" prop="by5">
                <template slot-scope="scope">
                    {{!!scope.row.by5 ? scope.row.by5 : "未添加评标报告"}}
                </template>
            </el-table-column>
            <el-table-column label="标段编号" prop="bdcode">
            </el-table-column>
            <el-table-column label="标段名称" prop="bdname">
            </el-table-column>
            <el-table-column label="交易中心" prop="pstime">
                <template slot-scope="scope">
                    <state-list
                        :row="scope.row" 
                        :config="STATE_CONF">
                    </state-list>
                    <push-type 
                        :column="scope.row" 
                        :pushPage="'pbbd'" 
                        :primaryKey="scope.row.bdcode"
                        :procode="getQuery('zbprocode')">
                    </push-type>
                </template>
            </el-table-column>
            <el-table-column label="详细信息" prop="pstime">
                <template slot-scope="scope">
                    <btn-list 
                        :row="scope.row"
                        :model="initModel"
                        @reload="reloadHandler"
                        @showTemplate="getTemplate(scope.row)"
                        :config="BTN_CONF">
                    </btn-list>
                </template>
            </el-table-column>
        </my-table>

        <my-pagination
            v-if="waitInit"
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('bidUrl')}/revision/kaibiao/pbbg/get_list.json`">
        </my-pagination>

        <el-dialog
        title="模板选择"
        :visible.sync="templateDialogVisible"
        :before-close="clearTemplate"
        width="60%">
            <pb-temlplate :data="pbTemlplateData" ref="pbTemplate"></pb-temlplate>
        </el-dialog>
        
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import STATE_CONF from './config/stateBtn'
import BTN_CONF from './config/btn-list'
import pbTemlplate from './components/pbTemlpate'
import PushType from '@/components-sys/push-type'

export default {
    mixins: [ LIST_PAGE_MIXIN ],
    components: { pbTemlplate,PushType },
    data() { 
        return {
            pgData: {
                zbprocode:"",
                isXingTai:"1",//邢台传1 其他不传
                zgys:"",//1为资格预审 不传不是
                ext5:"",
                sortname : 'a.bdcode',
				sortorder : "asc",
            },

            waitInit:false, //等待初始化
            zgys:"",
            initModel:{},

            pbTemlplateData:{
                bdcode:"",
            },
            templateDialogVisible:false,

            STATE_CONF,
            BTN_CONF,
        }
    },
    computed: {
        
    },                                                                                                                              
    methods: {
        //清空生成的模板
        clearTemplate(done){
            this.$refs.pbTemplate.clearTemplate();
            done();
        },
        //初始化列表
        initTable(){
            var that=this;         
            that.$get(`${this.getGetters('bidUrl')}/revision/kaibiao/pbbg/initList.json`,{
                zbprocode:that.getQuery('zbprocode'),
                isXingTai:!!that.getQuery('isXingTai') ? that.getQuery('isXingTai') : '',//邢台传1 其他不传
                zgys:that.pgData.zgys,
            }, (data, res) => {
                that.initModel = data.model;
                that.initModel.zgys = that.pgData.zgys;
                that.pgData.ext5 = data.model.ext5;
                that.waitInit = true;
            });
        },
        //选择模板
        getTemplate(row){
            var that=this;
            that.$get(`${this.getGetters('bidUrl')}/revision/kaibiao/pbbg/selectMb.json`,{
                bdcode:row.bdcode,
            }, (data, res) => {
                that.pbTemlplateData = data;
                that.pbTemlplateData.bdcode = row.bdcode;
                that.templateDialogVisible = true;
            });
        },
        
    },
    created() {
        
    },
    mounted() {
        this.pgData.zbprocode = this.getQuery('zbprocode');
        this.pgData.zgys = !!this.getQuery('zgys') ? this.getQuery('zgys') : '';
        this.initTable();
    }
}
</script>

<style scoped lang="scss">
</style>